import React, { useState, useEffect } from "react";
import Rootstock from "./Components/Navigation/Rootstock";
import StickySocialMedia from "./Components/Blog/Pages/socialmedia/StickySocialMedia";
import { Helmet } from "react-helmet";

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const scrollTopbtn = document.querySelector(".scroll-top");
    const progressPath = document.querySelector(".scroll-top path");

    if (scrollTopbtn && progressPath) {
      const pathLength = progressPath.getTotalLength();
      progressPath.style.transition = progressPath.style.WebkitTransition =
        "none";
      progressPath.style.strokeDasharray = pathLength + " " + pathLength;
      progressPath.style.strokeDashoffset = pathLength;
      progressPath.getBoundingClientRect();
      progressPath.style.transition = progressPath.style.WebkitTransition =
        "stroke-dashoffset 10ms linear";

      const updateProgress = () => {
        const scroll = window.scrollY;
        const height =
          document.documentElement.scrollHeight - window.innerHeight;
        const progress = pathLength - (scroll * pathLength) / height;
        progressPath.style.strokeDashoffset = progress;
      };

      const handleScroll = () => {
        updateProgress();
        setIsScrolled(window.scrollY > 50);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar, Bangalore</title>
        <meta name="description" content="Columbiaa Hospital is a leading multi-speciality hospital in Kasturi Nagar, Bangalore. We offer comprehensive healthcare services including cardiology, neurology, orthopedics, and more. Book appointments with top doctors today." />
        <meta name="keywords" content="hospital, multi-speciality hospital, Kasturi Nagar, Bangalore, doctors, healthcare, cardiology, neurology, orthopedics, best hospital" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar, Bangalore" />
        <meta property="og:description" content="Columbiaa Hospital is a leading multi-speciality hospital in Kasturi Nagar, Bangalore. We offer comprehensive healthcare services." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com" />
        <meta property="og:image" content="assets/images/zclogo.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar, Bangalore" />
        <meta name="twitter:description" content="Columbiaa Hospital is a leading multi-speciality hospital in Kasturi Nagar, Bangalore." />
        <link rel="canonical" href="https://columbiaahospital.com" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Hospital",
              "name": "Columbiaa Hospital",
              "description": "Leading multi-speciality hospital in Kasturi Nagar, Bangalore offering comprehensive healthcare services",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Kasturi Nagar",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "telephone": "+918044484444",
              "url": "https://columbiaahospital.com",
              "email": "care@columbiaahospital.com",
              "openingHours": [
                "Mo-Su 00:00-23:59"
              ],
              "medicalSpecialty": [
                "General Surgery",
                "Cardiology",
                "Neurology",
                "Orthopedics",
                "Nephrology",
                "Urology",
                "Gastroenterology",
                "Oncology"
              ],
              "areaServed": {
                "@type": "Place",
                "name": "Bangalore"
              },
              "sameAs": [
                "https://www.facebook.com/columbiaahospital",
                "https://x.com/columbiaahosp",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      <StickySocialMedia/>
      <div
        className={`scroll-top ${isScrolled ? "show" : ""}`}
        onClick={scrollTop}
        style={{
          zIndex: 9999
        }}
        aria-label="Scroll to top of page"
        role="button"
        tabIndex={0}
      >
        <i
          className="flaticon-up-arrow-1"
          style={{
            position: "relative",
            display: "block",
            fontSize: "30px",
            fontWeight: 400,
            marginTop: "30px",
          }}
          aria-hidden="true"
        ></i>
        <span className="sr-only">Top</span>
      </div>
      <Rootstock />
    </>
  );
}

export default App;
